import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../services/apiService';
import AdminDashboard from './dashboard/AdminDashboard';
import ClientDashboard from './dashboard/ClientDashboard';

const Dashboard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    console.log('Dashboard - Login status:', token ? 'Logged in' : 'Not logged in');
    if (!token) {
      console.log('No token found, redirecting to login...');
      navigate('/login');
    } else {
      fetchUserInfo();
    }
  }, [navigate]);

  const fetchUserInfo = () => {
    try {
      // Get user data from localStorage (stored during login)
      const userData = getCurrentUser();
      
      if (!userData) {
        console.log('No user data found in localStorage. User might not be logged in properly.');
        setUserRole(1); // Default to admin
        setIsLoading(false);
        return;
      }
      
      setCurrentUser(userData);
      
      // Debug: Log the full user data to understand the structure
      console.log('=== FULL USER DATA ===');
      console.log('userData:', userData);
      console.log('userData.role:', userData.role);
      console.log('typeof userData.role:', typeof userData.role);
      console.log('userData.role.number:', userData.role?.number);
      console.log('userData.role.id:', userData.role?.id);
      console.log('userData.role.name:', userData.role?.name);
      
      // Extract role information
      let roleNumber;
      let roleName;
      
      if (userData.role) {
        // Check if role is an object with number property
        if (userData.role.number) {
          roleNumber = userData.role.number;
          roleName = userData.role.name;
        }
        // Check if role is an object with id property
        else if (userData.role.id) {
          roleNumber = userData.role.id;
          roleName = userData.role.name;
        }
        // Check if role is a string (ObjectId)
        else if (typeof userData.role === 'string') {
          roleNumber = userData.role;
          roleName = 'UNKNOWN';
        }
        // Check if role is a number
        else if (typeof userData.role === 'number') {
          roleNumber = userData.role;
          roleName = 'UNKNOWN';
        }
        else {
          roleNumber = userData.role;
          roleName = 'UNKNOWN';
        }
      }
      
      setUserRole(roleNumber);
      console.log('Extracted roleNumber:', roleNumber);
      console.log('Extracted roleName:', roleName);
      console.log('Role type:', typeof roleNumber);
      
    } catch (error) {
      console.error('Error fetching user info:', error);
      // If we can't get user info, assume admin role for backward compatibility
      setUserRole(1);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="bg-gray-50 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  // Simplified role check
  // CLIENT role ID: 68cbb0c8ca57238aedb188bc (from your MongoDB data)
  // CLIENT role number: 3 (from your roles table)
  const isClient = userRole === 3 || 
                   userRole === '68cbb0c8ca57238aedb188bc' ||
                   (typeof userRole === 'string' && userRole.includes('68cbb0c8ca57238aedb188bc'));
  
  console.log('=== ROLE CHECK ===');
  console.log('userRole:', userRole);
  console.log('isClient:', isClient);
  console.log('Will show:', isClient ? 'ClientDashboard' : 'AdminDashboard');
  
  if (isClient) {
    return <ClientDashboard />;
  } else {
    return <AdminDashboard />;
  }
};

export default Dashboard;